const doc = [({"ko":({"adminConstantPromotionType":({"consecutiveStay":"연박 할인", "goto":"Go To 여행", "member":"회원 할인", "official":"공식 사이트 한정 할인", "promotionCode":"코드를 입력"})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;